import { ArrayDataSource } from './BaseDataSources';
import { IPackageType } from '../Interfaces';

export class PackageTypeSource extends ArrayDataSource<IPackageType> {
  public constructor() {
    super('/datasource/packagetypes');
  }
}